{
  "INBOX_MGMT": {
    "HEADER": "Iesūtnes",
    "DESCRIPTION": "Kanāls ir saziņas veids, ko klients izvēlas saziņai ar jums. Iesūtne ir vieta, kur pārvaldāt mijiedarbības ar noteiktu kanālu. Tas var ietvert saziņu no dažādiem avotiem, piemēram, e-pasta, tiešsaistes tērzēšanas un sociālajiem medijiem.",
    "LEARN_MORE": "Uzzināt vairāk par iesūtnēm",
    "RECONNECT": {
      "BUTTON": "Savienot atkārtoti",
      "FACEBOOK": "Savienojumam ar Facebook beidzās derīgums, vai tas tika atsaukts. Lapai sūtītās ziņas nenonāk šajā iesūtnē, un atbildes var netikt nosūtītas. Personai, kas pārvalda Facebook lapu, jānoklikšķina uz Savienot atkārtoti un jāpiesakās Facebook.",
      "INSTAGRAM": "Savienojumam ar Instagram beidzās derīgums, vai tas tika atsaukts. Kontam sūtītās ziņas nenonāk šajā iesūtnē, un atbildes var netikt nosūtītas. Noklikšķiniet uz Savienot atkārtoti un piesakieties tajā pašā Instagram kontā. Cits konts izveido jaunu iesūtni.",
      "GOOGLE": "Savienojumam ar Google beidzās derīgums, vai tas tika atsaukts. Jauni e-pasti nenonāk šajā iesūtnē, un atbildes var netikt nosūtītas. Noklikšķiniet uz Savienot atkārtoti un piesakieties Google kā {email}.",
      "MICROSOFT": "Savienojumam ar Microsoft beidzās derīgums, vai tas tika atsaukts. Jauni e-pasti nenonāk šajā iesūtnē, un atbildes var netikt nosūtītas. Noklikšķiniet uz Savienot atkārtoti un piesakieties Microsoft kā {email}.",
      "ALLEGRO": "Savienojumam ar Allegro beidzās derīgums, vai tas tika atsaukts. Pircēju ziņas nenonāk šajā iesūtnē, un atbildes var netikt nosūtītas. Noklikšķiniet uz Savienot atkārtoti un piesakieties Allegro kā pārdevējs {seller}. Cits pārdevēja konts izveido jaunu iesūtni.",
      "IMAP_LOGIN": "Pasta serveris noraida IMAP pieteikšanos {login}. Jauni e-pasti šajā pastkastē nenonāk. Pārbaudiet IMAP lietotājvārdu un paroli cilnē {tab} un saglabājiet tos. Mēs turpinām mēģināt pieteikties, un pastkaste atjaunosies, tiklīdz pieteikšanās izdosies.",
      "WHATSAPP": "Savienojums ar WhatsApp ir beidzies vai atsaukts. Klientu pielikumi nenonāk šajā iesūtnē, un atbildes var neizdoties. Noklikšķiniet uz Savienot atkārtoti, piesakieties Facebook un vēlreiz izvēlieties numuru {phone}."
    },
    "LIST": {
      "404": "Šim kontam nav pievienota neviena Iesūtne.",
      "RECONNECT_REQUIRED": "Nepieciešams savienot no jauna"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Izvēlieties Kanālu",
        "BODY": "Izvēlieties pakalpojumu sniedzēju, kuru vēlaties integrēt ar tērzēšanu."
      },
      "INBOX": {
        "TITLE": "Izveidot Iesūtni",
        "BODY": "Autentificēt savu kontu un izveidot iesūtni."
      },
      "AGENT": {
        "TITLE": "Pievienot Aģentus",
        "BODY": "Pievienojiet aģentus izveidotajai iesūtnei."
      },
      "FINISH": {
        "TITLE": "Gatavs!",
        "BODY": "Jūs varat sākt darboties!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Iesūtnes Nosaukums",
        "PLACEHOLDER": "Ievadiet Jūsu iesūtnes nosaukumu (piemēram: Acme Inc)",
        "ERROR": "Lūdzu, ievadiet derīgu iesūtnes nosaukumu"
      },
      "WEBSITE_NAME": {
        "LABEL": "Tīmekļa Vietnes Nosaukums",
        "PLACEHOLDER": "Ievadiet Jūsu tīmekļa vietnes nosaukumu (piemēram: Acme Inc)"
      },
      "INTERNAL_NAME": {
        "LABEL": "Iekšējais Nosaukums",
        "PLACEHOLDER": "Nosauciet iesūtni, kā tā tiks rādīta šajā informācijas panelī",
        "ERROR": "Lūdzu, ievadiet unikālu iekšējo nosaukumu"
      },
      "FB": {
        "HELP": "PS: Pierakstoties mēs iegūstam piekļuvi tikai pie Jūsu lapas ziņojumiem. Mēs nekad nevaram piekļūt jūsu privātajām ziņām.",
        "CHOOSE_PAGE": "Izvēlieties Lapu",
        "CHOOSE_PLACEHOLDER": "Izvēlieties lapu no saraksta",
        "INBOX_NAME": "Iesūtnes Nosaukums",
        "ADD_NAME": "Pievienojiet savas iesūtnes nosaukumu",
        "PICK_NAME": "Lūdzu ievadiet Iesūtnes nosaukumu",
        "PICK_A_VALUE": "Izvēlieties vērtību",
        "CREATE_INBOX": "Izveidot Iesūtni"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Turpināt ar Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Savienot Jūsu Instagram Profilu",
        "HELP": "Lai pievienotu savu Instagram profilu kā kanālu, Jums jāautentificē savs Instagram profils, noklikšķinot uz 'Turpināt ar Instagram' ",
        "ERROR_MESSAGE": "Radās kļūda, savienojoties ar Instagram, lūdzu, mēģiniet vēlreiz",
        "ERROR_AUTH": "Radās kļūda, savienojoties ar Instagram, lūdzu, mēģiniet vēlreiz",
        "NEW_INBOX_SUGGESTION": "Šis Instagram konts iepriekš bija saistīts ar citu iesūtni un tagad ir pārcelts uz šejieni. Visi jaunie ziņojumi turpmāk parādīsies šeit. Vecā iesūtne vairs nevarēs sūtīt vai saņemt ziņojumus šim kontam.",
        "DUPLICATE_INBOX_BANNER": "Šis Instagram konts ir pārcelts uz jauno Instagram kanāla iesūtni. Jūs vairs nevarēsiet sūtīt/saņemt Instagram ziņojumus no šīs iesūtnes."
      },
      "TWITTER": {
        "HELP": "Lai pievienotu savu Twitter profilu kā kanālu, Jums ir jāautentificē savs Twitter profils, noklikšķinot uz \"Pierakstīties ar Twitter\"' ",
        "ERROR_MESSAGE": "Radās kļūda, veidojot savienojumu ar Twitter. Lūdzu, mēģiniet vēlreiz",
        "TWEETS": {
          "ENABLE": "Izveidot sarunas no minētajiem Tvītiem"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Tīmekļa vietnes kanāls",
        "DESC": "Izveidot savai tīmekļa vietnei kanālu un sākt atbalstīt savus klientus, izmantojot mūsu tīmekļu vietnes logrīku.",
        "LOADING_MESSAGE": "Tiek Veikta Tīmekļa Vietnes Atbalsta Kanāla Izveide",
        "CHANNEL_AVATAR": {
          "LABEL": "Kanāla Avatārs"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Lūdzu ievadiet Webhook URL",
          "ERROR": "Lūdzu, ievadiet derīgu URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Tīmekļa Vietnes Domēns",
          "PLACEHOLDER": "Ievadiet savas tīmekļa vietnes domēnu (piemēram: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Laipni lūdzam Virsraksts",
          "PLACEHOLDER": "Sveicināti !"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Laipni lūdzam Teksts",
          "PLACEHOLDER": "Sazināties ar mums ir vienkārši. Vaicājiet mums jebko, vai dalieties ar savām atsauksmēm."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Kanāla sveiciena paziņojums",
          "PLACEHOLDER": "Acme Inc parasti atbild dažu stundu laikā."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Iespējot kanāla sveicienu",
          "HELP_TEXT": "Automātiski nosūtīt sveiciena paziņojumu, kad tiek izveidota jauna saruna.",
          "ENABLED": "Iespējots",
          "DISABLED": "Atspējots"
        },
        "REPLY_TIME": {
          "TITLE": "Iestatīt Atbildes laiku",
          "IN_A_FEW_MINUTES": "Dažās minutēs",
          "IN_A_FEW_HOURS": "Dažās stundās",
          "IN_A_DAY": "Dienas laikā",
          "HELP_TEXT": "Šis atbildes laiks tiks parādīts tiešsaistes tērzēšanas logrīkā"
        },
        "WIDGET_COLOR": {
          "LABEL": "Logrīka Krāsa",
          "PLACEHOLDER": "Atjaunināt logrīkā izmantoto logrīka krāsu"
        },
        "SUBMIT_BUTTON": "Izveidot iesūtni",
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām izveidot tīmekļa vietnes kanālu. Lūdzu, mēģiniet vēlreiz"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp Kanāls",
        "DESC": "Integrēt Twilio un sākt atbalstīt savus klientus, izmantojot SMS vai WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Konta SID",
          "PLACEHOLDER": "Lūdzu, ievadiet sava Twilio konta SID",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "API_KEY": {
          "USE_API_KEY": "Izmantot API Atslēgas Autentifikāciju",
          "LABEL": "API Atslēgas SID",
          "PLACEHOLDER": "Lūdzu, ievadiet savu API Atslēgas SID",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Atslēgas Noslēpums",
          "PLACEHOLDER": "Lūdzu, ievadiet savu API Atslēgas Noslēpumu",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Ziņapmaiņas Pakalpojuma SID",
          "PLACEHOLDER": "Lūdzu, ievadiet savu Twilio ziņojumapmaiņas pakalpojuma SID",
          "ERROR": "Šis lauks ir nepieciešams",
          "USE_MESSAGING_SERVICE": "Izmantot Twilio Ziņojumapmaiņas Pakalpojumu"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Kanāla Tips",
          "ERROR": "Lūdzu, izvēlieties sava Kanāla Tipu"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth Token",
          "PLACEHOLDER": "Lūdzu, ievadiet savu Twilio Auth Token",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "CHANNEL_NAME": {
          "LABEL": "Iesūtnes Nosaukums",
          "PLACEHOLDER": "Lūdzu, ievadiet iesūtnes nosaukumu",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefona numurs",
          "PLACEHOLDER": "Lūdzu, ievadiet tālruņa numuru, no kura tiks nosūtīts ziņojums.",
          "ERROR": "Lūdzu, norādiet derīgu tālruņa numuru, kas sākas ar zīmi “+” un nesatur atstarpes."
        },
        "API_CALLBACK": {
          "TITLE": "Atzvanīšanas URL",
          "SUBTITLE": "Jums ir jānokonfigurē Twilio pakalpojumā ziņojumu atzvanīšanas URL, izmantojot šeit minēto URL."
        },
        "SUBMIT_BUTTON": "Izveidot Twilio Kanālu",
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām autentificēt Twilio akreditācijas datus. Lūdzu, mēģiniet vēlreiz"
        }
      },
      "SMS": {
        "TITLE": "SMS Kanāls",
        "DESC": "Sāciet atbalstīt savus klientus, izmantojot SMS.",
        "PROVIDERS": {
          "LABEL": "API Pakalpojumu Sniedzējs",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām saglabāt SMS kanālu"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Konta ID",
            "PLACEHOLDER": "Lūdzu, ievadiet savu Bandwidth konta ID",
            "ERROR": "Šis lauks ir nepieciešams"
          },
          "API_KEY": {
            "LABEL": "API atslēga",
            "PLACEHOLDER": "Lūdzu ievadiet Bandwidth API Key",
            "ERROR": "Šis lauks ir nepieciešams"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Lūdzu ievadiet Bandwidth API Secret",
            "ERROR": "Šis lauks ir nepieciešams"
          },
          "APPLICATION_ID": {
            "LABEL": "Lietojumprogrammas ID",
            "PLACEHOLDER": "Lūdzu, ievadiet savu Bandwidth lietojumprogrammas ID",
            "ERROR": "Šis lauks ir nepieciešams"
          },
          "INBOX_NAME": {
            "LABEL": "Iesūtnes Nosaukums",
            "PLACEHOLDER": "Lūdzu, ievadiet iesūtnes nosaukumu",
            "ERROR": "Šis lauks ir nepieciešams"
          },
          "PHONE_NUMBER": {
            "LABEL": "Tālruņa numurs",
            "PLACEHOLDER": "Lūdzu, ievadiet tālruņa numuru, no kura tiks nosūtīts ziņojums.",
            "ERROR": "Lūdzu, norādiet derīgu tālruņa numuru, kas sākas ar zīmi “+” un nesatur atstarpes."
          },
          "SUBMIT_BUTTON": "Izveidot Bandwidth kanālu",
          "API": {
            "ERROR_MESSAGE": "Mēs nevarējām autentificēt Bandwidth akreditācijas datus. Lūdzu, mēģiniet vēlreiz"
          },
          "API_CALLBACK": {
            "TITLE": "Atzvanīšanas URL",
            "SUBTITLE": "Jums ir jānokonfigurē Bandwidth ziņojumu atzvanīšanas URL, izmantojot šeit minēto URL."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Iesūtnes Nosaukums",
            "PLACEHOLDER": "Lūdzu, ievadiet iesūtnes nosaukumu",
            "ERROR": "Šis lauks ir obligāts"
          },
          "PHONE_NUMBER": {
            "LABEL": "Tālruņa numurs",
            "PLACEHOLDER": "Lūdzu, ievadiet tālruņa numuru, no kura tiks sūtīti ziņojumi.",
            "ERROR": "Lūdzu, norādiet derīgu tālruņa numuru, kas sākas ar zīmi `+`."
          },
          "SUBMIT_BUTTON": "Izveidot SMS Brana Kanālu",
          "API": {
            "ERROR_MESSAGE": "Mums neizdevās izveidot SMS Brana kanālu"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Iesūtnes Nosaukums",
            "PLACEHOLDER": "Lūdzu, ievadiet iesūtnes nosaukumu",
            "ERROR": "Šis lauks ir obligāts"
          },
          "PHONE_NUMBER": {
            "LABEL": "Tālruņa numurs",
            "PLACEHOLDER": "Lūdzu, ievadiet tālruņa numuru, no kura tiks sūtīti ziņojumi.",
            "ERROR": "Lūdzu, norādiet derīgu tālruņa numuru, kas sākas ar zīmi `+`."
          },
          "SUBMIT_BUTTON": "Izveidot DIDWW Kanālu",
          "API": {
            "ERROR_MESSAGE": "Mums neizdevās izveidot DIDWW kanālu"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API Pakalpojumu Sniedzējs",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Jums Facebook izstrādātāju portālā ir jānokonfigurē webhoot URL un verifikācijas token ar tālāk norādītajām vērtībām.",
          "WEBHOOK_URL": "Webhook URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook Verifikācijas Token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Ātrā Iestatīšana ar Meta",
          "DESC": "Jūs tiksiet novirzīts uz Meta, lai pieteiktos savā WhatsApp Business kontā. Administratora piekļuve palīdzēs padarīt iestatīšanu vienkāršu un ērtu.",
          "BENEFITS": {
            "EASY_SETUP": "Nav nepieciešama manuāla konfigurēšana",
            "SECURE_AUTH": "Droša, uz OAuth balstīta autentifikācija",
            "AUTO_CONFIG": "Automātiska webhook un tālruņa numura konfigurēšana"
          },
          "SUBMIT_BUTTON": "Savienot ar WhatsApp Business",
          "AUTH_PROCESSING": "Notiek autentifikācija ar Meta",
          "WAITING_FOR_BUSINESS_INFO": "Lūdzu, pabeidziet uzņēmuma iestatīšanu Meta logā...",
          "PROCESSING": "Notiek Jūsu WhatsApp Business konta iestatīšana",
          "CANCELLED": "WhatsApp reģistrācija tika atcelta",
          "WAITING_FOR_AUTH": "Gaida autentifikāciju...",
          "INVALID_BUSINESS_DATA": "Saņemti nederīgi uzņēmuma dati no Facebook. Lūdzu, mēģiniet vēlreiz.",
          "SIGNUP_ERROR": "Radās reģistrācijas kļūda",
          "SDK_LOAD_ERROR": "Neizdevās ielādēt Facebook SDK. Lūdzu, mēģiniet vēlreiz.",
          "AUTH_NOT_COMPLETED": "Autentifikācija nav pabeigta. Lūdzu, sāciet procesu no jauna.",
          "SUCCESS_FALLBACK": "WhatsApp Business konts ir veiksmīgi konfigurēts",
          "RECONNECTED": "WhatsApp kanāls veiksmīgi pievienots atkārtoti"
        },
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām saglabāt WhatsApp kanālu"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API Kanāls",
        "DESC": "Integrēt ar API kanālu un sākt atbalstīt savus klientus.",
        "CHANNEL_NAME": {
          "LABEL": "Kanāla Nosaukums",
          "PLACEHOLDER": "Lūdzu, ievadiet kanāla nosaukumu",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook URL",
          "SUBTITLE": "Konfigurēt URL, kurā vēlaties saņemt notikumu atzvanus.",
          "PLACEHOLDER": "Webhook URL"
        },
        "SUBMIT_BUTTON": "Izveidot API kanālu",
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām saglabāt API kanālu"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce kanāls",
        "DESC": "Integrējiet ar Salesforce kanālu un sāciet atbalstīt savus klientus.",
        "CHANNEL_NAME": {
          "LABEL": "Kanāla Nosaukums",
          "PLACEHOLDER": "Lūdzu, ievadiet kanāla nosaukumu",
          "ERROR": "Šis lauks ir obligāts"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API URL",
          "SUBTITLE": "Konfigurējiet bāzes URL savai Salesforce instancei.",
          "PLACEHOLDER": "Salesforce API URL"
        },
        "KEY_ID": {
          "LABEL": "Atslēgas ID",
          "SUBTITLE": "Atslēgas ID Jūsu Salesforce kanālam.",
          "PLACEHOLDER": "ATSLĒGAS ID"
        },
        "SECRET": {
          "LABEL": "Slepenā Atslēga",
          "SUBTITLE": "Slepenā atslēga Jūsu Salesforce kanālam.",
          "PLACEHOLDER": "*****"
        },
        "SUBMIT_BUTTON": "Izveidot Salesforce Kanālu",
        "API": {
          "ERROR_MESSAGE": "Mums neizdevās saglabāt Salesforce kanālu"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook URL",
          "SUBTITLE": "Jums Salesforce jākonfigurē webhook URL, izmantojot šeit norādīto URL."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Izmantojiet šo bearer token autentifikācijai, konfigurējot webhook pakalpojumā Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Aizstāt E-pasta Sūtītāju",
          "SUBTITLE": "Ja iestatīts, šī e-pasta adrese tiks izmantota kā sūtītājs visiem izejošajiem e-pastiem, nevis sarunas avota e-pasts.",
          "PLACEHOLDER": "piem., support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro kanāls",
        "DESC": "Pievienojiet Allegro pārdevēja kontu un atbildiet uz tā ziņojumu centra ziņojumiem no Kontaktu centra.",
        "CHANNEL_NAME": {
          "LABEL": "Iesūtnes Nosaukums",
          "SUBTITLE": "Nosaukums, ko aģenti redz šai iesūtnei.",
          "PLACEHOLDER": "Ievadiet iesūtnes nosaukumu",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "SUBMIT_BUTTON": "Pierakstīties ar Allegro",
        "API": {
          "ERROR_MESSAGE": "Veidojot savienojumu ar Allegro, radās kļūda, lūdzu, mēģiniet vēlreiz"
        },
        "SELLER_LOGIN": {
          "TITLE": "Allegro pieteikšanās",
          "SUBTITLE": "Pārdevēja konts, kura ziņojumus šī iesūtne lasa un uz kuriem atbild."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland kanāls",
        "DESC": "Atbildiet uz pieteikumu ziņojumiem, ko pircēji Jums sūta Kaufland tirdzniecības vietā.",
        "CHANNEL_NAME": {
          "LABEL": "Kanāla Nosaukums",
          "PLACEHOLDER": "Lūdzu, ievadiet kanāla nosaukumu",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "32 rakstzīmju Client Key no Jūsu Kaufland pārdevēja konta API iestatījumu lapas.",
          "PLACEHOLDER": "32 rakstzīmju atslēga",
          "ERROR": "Ievadiet 32 rakstzīmju Client Key"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "64 rakstzīmju Secret Key, kas pieder Client Key. Kaufland to parāda vienu reizi, un tā nekad netiek nosūtīta atpakaļ uz šo lapu.",
          "PLACEHOLDER": "64 rakstzīmju atslēga",
          "ERROR": "Ievadiet 64 rakstzīmju Secret Key"
        },
        "SUBMIT_BUTTON": "Izveidot Kaufland Kanālu",
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām saglabāt Kaufland kanālu"
        },
        "DISCONNECTED": {
          "TITLE": "Atvienots",
          "MESSAGE": "Kaufland noraidīja šīs API atslēgas. Ievadiet Client Key un Secret Key vēlreiz, lai atkārtoti savienotu šo iesūtni."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "E-pasta Kanāls",
        "DESC": "Integrēt sava e-pasta iesūtni.",
        "CHANNEL_NAME": {
          "LABEL": "Kanāla Nosaukums",
          "PLACEHOLDER": "Lūdzu, ievadiet kanāla nosaukumu",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "EMAIL": {
          "LABEL": "E-pasts",
          "SUBTITLE": "Norādiet e-pasta adresi, uz kuru Jūsu klienti sūta atbalsta pieprasījumus.",
          "PLACEHOLDER": "E-pasts"
        },
        "SUBMIT_BUTTON": "Izveidot E-pasta Kanālu",
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām saglabāt e-pasta kanālu"
        },
        "FINISH_MESSAGE": "Sākt pārsūtīt savus e-pasta ziņojumus uz tālāk norādīto e-pasta adresi."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE Kanāls",
        "DESC": "Integrēt ar LINE kanālu un sākt atbalstīt savus klientus.",
        "CHANNEL_NAME": {
          "LABEL": "Kanāla Nosaukums",
          "PLACEHOLDER": "Lūdzu, ievadiet kanāla nosaukumu",
          "ERROR": "Šis lauks ir nepieciešams"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE Kanāla ID",
          "PLACEHOLDER": "LINE Kanāla ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE Kanāla Secret",
          "PLACEHOLDER": "LINE Kanāla Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE Kanāla Token",
          "PLACEHOLDER": "LINE Kanāla Token"
        },
        "SUBMIT_BUTTON": "Izveidot LINE Kanālu",
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām saglabāt LINE kanālu"
        },
        "API_CALLBACK": {
          "TITLE": "Atzvanīšanas URL",
          "SUBTITLE": "Jums LINE lietojumprogrammā ir jānokonfigurē webhook URL, ar šeit minēto URL."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram Kanāls",
        "DESC": "Integrēt ar Telegram kanālu un sākt atbalstīt savus klientus.",
        "BOT_TOKEN": {
          "LABEL": "Bot Token",
          "SUBTITLE": "Konfigurēt bot token, ko ieguvāt no Telegram BotFather.",
          "PLACEHOLDER": "Bot Token"
        },
        "SUBMIT_BUTTON": "Izveidot Telegram Kanālu",
        "API": {
          "ERROR_MESSAGE": "Mēs nevarējām saglabāt Telegram kanālu"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Tālruņa zvani",
        "DESC": "Iestatiet, kuri tālruņa zvani tiks rādīti šajā iesūtnē.",
        "NAME": {
          "LABEL": "Iesūtnes nosaukums",
          "SUBTITLE": "Izvēlieties viegli atpazīstamu nosaukumu."
        },
        "PHONE_NUMBER": {
          "LABEL": "Tālruņa numurs",
          "SUBTITLE": "Ievadiet tālruņa numurus, kas pieder šai iesūtnei, vēlāk varat pievienot vēl numurus.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Izveidot Tālruņa Zvanu Iesūtni",
        "API": {
          "ERROR_MESSAGE": "Mums neizdevās izveidot iesūtni"
        }
      },
      "AUTH": {
        "TITLE": "Izvēlieties kanālu",
        "DESC": "Tērzēšana atbalsta tiešraides tērzēšanas logrīkus, Facebook Messenger, WhatsApp, e-pastus kā kanālus. Ja vēlaties izveidot pielāgotu kanālu, varat to izveidot, izmantojot API kanālu. Lai sāktu, izvēlieties vienu no tālāk norādītajiem kanāliem."
      },
      "AGENTS": {
        "TITLE": "Aģenti",
        "DESC": "Šeit Jūs varat pievienot aģentus, lai pārvaldītu savu jaunizveidoto iesūtni. Tikai šiem atlasītajiem aģentiem būs piekļuve Jūsu iesūtnei. Aģenti, kas neietilpst šajā iesūtnē, nevarēs redzēt ziņojumus vai atbildēt uz ziņojumiem šajā iesūtnē, kad būs pierakstījušies sistēmā. <br> <b>PS:</b> Ja jums kā administratoram ir nepieciešama piekļuve pie visām iesūtnēm, jums ir jāpievieno sevi kā aģentu visām izveidotajām iesūtnēm.",
        "VALIDATION_ERROR": "Pievienojiet savai jaunajai iesūtnei vismaz vienu aģentu",
        "PICK_AGENTS": "Izvēlieties aģentus priekš iesūtnes"
      },
      "DETAILS": {
        "TITLE": "Informācija par Iesūtni",
        "DESC": "Tālāk esošajā nolaižamajā izvēlnē izvēlieties Facebook lapu, kuru vēlaties savienot ar tērzēšanu. Jūs varat savai iesūtnei, lai to labāk atpazītu, piešķirt pielāgotu nosaukumu."
      },
      "FINISH": {
        "TITLE": "Sanāca!",
        "DESC": "Jūs esat veiksmīgi pabeidzis savas Facebook lapas integrēšanu ar tērzēšanu. Nākamreiz, kad klients nosūtīs ziņojumu Jūsu lapai, saruna automātiski parādīsies Jūsu iesūtnē.<br>Mēs nodrošinām Jums arī logrīka skriptu, ko varat viegli pievienot savai tīmekļa vietnei. Kad tas būs pieejams Jūsu vietnē, klienti varēs Jums nosūtīt ziņojumus tieši no Jūsu tīmekļa vietnes, neizmantojot ārējus rīkus, un saruna tiks parādīta tieši šeit, tērzēšanā.<br>"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Izvēlieties savu e-pasta pakalpojumu sniedzēju",
        "DESCRIPTION": "Tālāk esošajā sarakstā izvēlieties e-pasta pakalpojumu sniedzēju. Ja sarakstā neredzat savu e-pasta pakalpojumu sniedzēju, varat izvēlēties citu pakalpojumu sniedzēja opciju un norādīt IMAP un SMTP akreditācijas datus."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Lai sāktu, noklikšķiniet uz pogas Pierakstīties ar Microsoft. Jūs tiksit novirzīts uz e-pasta pierakstīšanās lapu. Kad būsiet pieņēmis pieprasītās atļaujas, Jūs tiksit novirzīts atpakaļ uz iesūtnes izveides darbību.",
        "EMAIL_PLACEHOLDER": "Ievadiet e-pasta adresi",
        "SIGN_IN": "Pierakstīties ar Microsoft",
        "ERROR_MESSAGE": "Veidojot savienojumu ar Microsoft, radās kļūda. Lūdzu, mēģiniet vēlreiz"
      },
      "GOOGLE": {
        "TITLE": "Google e-pasts",
        "DESCRIPTION": "Lai sāktu, noklikšķiniet uz pogas Pierakstīties ar Google. Jūs tiksit novirzīts uz e-pasta pierakstīšanās lapu. Kad būsiet pieņēmis pieprasītās atļaujas, jūs tiksit novirzīts atpakaļ uz iesūtnes izveides darbību.",
        "SIGN_IN": "Pierakstīties ar Google",
        "EMAIL_PLACEHOLDER": "Ievadiet e-pasta adresi",
        "ERROR_MESSAGE": "Veidojot savienojumu ar Google, radās kļūda. Lūdzu, mēģiniet vēlreiz"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Notiek Jūsu autentificēšana, izmantojot Facebook...",
      "ERROR_FB_LOADING": "Ielādējot Facebook SDK, radās kļūda. Lūdzu, atspējojiet visus reklāmu bloķētājus un mēģiniet vēlreiz no citas pārlūkprogrammas.",
      "ERROR_FB_AUTH": "Radās kļūda. Lūdzu, atsvaidziniet lapu...",
      "ERROR_FB_UNAUTHORIZED": "Jums nav tiesību veikt šo darbību. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Lūdzu, pārliecinieties, ka Jums ir pilna piekļuve Facebook lapai. Vairāk par Facebook lomām varat lasīt <a href=\" https://www.facebook.com/help/187316341316631\">šeit</a>.",
      "ERROR_CHANNEL_CREATION": "Neizdevās izveidot iesūtni. Lūdzu, mēģiniet vēlreiz.",
      "CREATING_CHANNEL": "Notiek Iesūtnes izveide...",
      "TITLE": "Nokonfigurēt Iesūtnes Informāciju",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Pievienot aģentus",
      "ADD_AGENTS": "Notiek aģentu pievienošana Jūsu iesūtnei..."
    },
    "FINISH": {
      "TITLE": "Jūsu Iesūtne ir gatava!",
      "MESSAGE": "Tagad Jūs varat izmantot savu jauno Kanālu lai sazinātos ar saviem klientiem. Priecīgu atbalstīšanu",
      "BUTTON_TEXT": "Iet uz",
      "MORE_SETTINGS": "Papildu iestatījumi",
      "WEBSITE_SUCCESS": "Jūs esat veiksmīgi pabeidzis tīmekļa vietnes kanāla izveidi. Nokopējiet tālāk redzamo kodu un ievietojiet to savā tīmekļa vietnē. Nākamreiz, kad klients izmantos tiešsaistes tērzēšanu, saruna automātiski tiks parādīta Jūsu iesūtnē."
    },
    "REAUTH": "Atkārtoti autorizēties",
    "VIEW": "Apskatīt",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Iesūtnes iestatījumi ir veiksmīgi atjaunināti",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automātiskā piešķiršana ir veiksmīgi atjaunināta",
        "ERROR_MESSAGE": "Mēs nevarējām atjaunināt iesūtnes iestatījumus. Lūdzu, vēlāk pamēģiniet vēlreiz."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Iespējots",
        "DISABLED": "Atspējots"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Iespējots",
        "DISABLED": "Atspējots"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Iespējots",
        "DISABLED": "Atspējots"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sūtītāja vārds",
        "SUB_TEXT": "Izvēlieties vārdu, kas tiks rādīts jūsu klientam, saņemot e-pasta ziņojumus no jūsu aģentiem.",
        "FOR_EG": "Piemēram:",
        "FRIENDLY": {
          "TITLE": "Draudzīgs",
          "FROM": "no",
          "SUBTITLE": "Sūtītāja vārdā pievienojiet tā aģenta vārdu, kurš nosūtīja atbildi, lai atbilde būtu draudzīga."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesionāls",
          "SUBTITLE": "Izmantot tikai konfigurēto uzņēmuma nosaukumu kā sūtītāja vārdu e-pasta galvenē."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Konfigurēt uzņēmuma nosaukumu",
          "PLACEHOLDER": "Ievadiet uzņēmuma nosaukumu",
          "SAVE_BUTTON_TEXT": "Saglabāt"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Iespējots",
        "DISABLED": "Atspējots"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Iespējots",
        "DISABLED": "Atspējots"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Nav"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Iespējots",
        "DISABLED": "Atspējots"
      },
      "ENABLE_HMAC": {
        "LABEL": "Iespējot"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Iespējots",
        "DISABLED": "Atspējots"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Iespējots",
        "DISABLED": "Atspējots"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Iespējot ienākošo e-pastu sinhronizāciju"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Iespējot pielāgotu e-pasta domēnu (maksas pakalpojums)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Iespējot Facebook komentāru apstrādi"
      },
      "SIGNATURE": {
        "TITLE": "HTML Paraksts",
        "SUB_TEXT": "Šis paraksts tiks pievienots katra no šīs iesūtnes nosūtītā ziņojuma kājenei.",
        "HTML_CONTENT": "HTML kods",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} tiks aizstāts ar aģenta vārdu.\n{'{{'}email{'}}'} tiks aizstāts ar tā aģenta e-pasta adresi, kurš nosūtīja e-pastu.\n{'{{'}position{'}}'} tiks aizstāts ar aģenta amatu.\n{'{{'}custom_line{'}}'} tiks aizstāts ar aģenta pielāgoto rindu.\n{'{{'}email_signature_picture{'}}'} tiks aizstāts ar aģenta e-pasta paraksta attēla URL (nevis attēla tagu) — izmantojiet to kā attēla avotu (img taga src).",
        "PREVIEW": "Priekšskatījums"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Paraksti pēc valsts",
        "SUB_TEXT": "Atbilde saņem pircēja valsts parakstu.",
        "HELP": "Atbilde tiek parakstīta pēc sarakstes valsts: pēc Kaufland veikala, Allegro pasūtījuma tirgus vietas vai, ja to nav, pēc valodas, kurā raksta pircējs. Ja valsts nav zināma vai tai šeit nav paraksta, tiek izmantots iepriekš norādītais HTML paraksts. Tirgus vietas aizliedz saites uz jūsu vietni un kontaktinformāciju, tāpēc atstājiet tikai sveicienu un {'{{'}name{'}}'}.",
        "EMPTY": "Jums vēl nav valstu parakstu, tāpēc atbildēs tiek izmantots iepriekš norādītais HTML paraksts.",
        "COUNTRY": "Izvēlieties valsti",
        "ADD": "Pievienot valsts parakstu",
        "REMOVE": "Noņemt"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Tālruņa Numura Sastādīšanas Prefikss",
        "PLACEHOLDER": "Ievadiet prefiksu pareizai zvanu maršrutēšanai (piem., *99)",
        "HELP_TEXT": "Šis prefikss tiks automātiski pievienots kontaktpersonu tālruņa numuru priekšā, zvanot no šīs iesūtnes."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Pogas “Atrisināsim vēlāk” teksts",
        "PLACEHOLDER": "piem., Šo tēmu atrisināsim pa e-pastu. Tagad vēlos jautāt par kaut ko citu.",
        "HELP_TEXT": "Logrīka pogas teksts, ar kuru apmeklētājs pamet pašreizējo tēmu un jautā par kaut ko citu. Atstājiet lauku tukšu, lai izmantotu noklusējuma tekstu apmeklētāja valodā."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Automātiski atlikt neatbildētos zvanus uz X minūtēm",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Automātiski atliek neatbildētos zvanus uz norādīto minūšu skaitu. Atstājiet tukšu vai 0, lai atspējotu."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Atrisināt neatbildēto zvanu pēc X neveiksmīgiem atzvaniem",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Kad uz neatbildēto zvanu ir atzvanīts X reizes un klients nav atbildējis, tas tiek automātiski atrisināts un tam tiek pievienota privāta piezīme. Atstājiet tukšu vai 0, lai atspējotu."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Jautājumu Ieteikumi",
        "SUB_TEXT": "Konfigurējiet iepriekš definētus jautājumus, ko klienti var izmantot saziņai ar Jūsu aģentiem.",
        "QUESTIONS_LABEL": "Jautājumi",
        "ADD_QUESTION": "Pievienot Jautājumu",
        "REMOVE": "Noņemt",
        "QUESTION_TEXT": "Burbulī attēlotais teksts.",
        "QUESTION_TEXT_PLACEHOLDER": "Obligāts",
        "QUESTION_PAYLOAD": "Teksts, kas tiek nosūtīts, noklikšķinot.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Nav obligāts",
        "NO_BOT_MESSAGE": "Lai ģenerētu papildu AI ieteikumus, lūdzu, pievienojiet robotu.",
        "BOT_CONNECTED_MESSAGE": "AI jautājumu ieteikumus no robota var aktivizēt tā",
        "BOT_SETTINGS_LINK": "iestatījumos"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternatīvās e-pasta adreses",
        "SUB_TEXT": "Papildu adreses, kas šai iesūtnei jāuzskata par savām, saņemot pārsūtītu pastu.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Pievienot",
        "REMOVE": "Noņemt",
        "EMPTY": "Nav konfigurētu alternatīvo e-pasta adrešu.",
        "HELP_TEXT": "Kad e-pasts pienāk ar vienu no šīm adresēm kā saņēmēju, atbildes tiks sūtītas no tās pašas adreses kā sūtītāja. Pārliecinieties, ka jūsu izejošais SMTP serveris atļauj sūtīšanu no šīm adresēm.",
        "SIGNATURE_LABEL": "Paraksts",
        "PRIMARY_SIGNATURE": "Galvenais (noklusējums)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Papildu paraksti",
        "SUB_TEXT": "Šeit definējiet papildu parakstus un pēc tam piešķiriet tos tālāk norādītajiem alternatīvajiem e-pastiem.",
        "OPTION": "Paraksts {number}",
        "ADD": "Pievienot parakstu",
        "REMOVE": "Noņemt",
        "HELP_TEXT": "Kad atbilde tiek nosūtīta no alternatīva e-pasta, tam piešķirtais paraksts tiek izmantots iesūtnes paraksta vietā. Alternatīvie e-pasti, kas atstāti uz „Galvenais (noklusējums)”, izmanto iesūtnes parakstu."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Dzēst",
      "AVATAR_DELETE_BUTTON_TEXT": "Dzēst Avatāru",
      "DELETE_REQUESTED_TOOLTIP": "Šī iesūtne ir atzīmēta dzēšanai",
      "RESTORE_BUTTON_TEXT": "Atjaunot",
      "CONFIRM": {
        "TITLE": "Apstiprināt Dzēšanu",
        "MESSAGE": "Vai vēlaties izdzēst ",
        "PLACE_HOLDER": "Lūdzu, uzrakstiet {inboxName} lai apstiprinātu",
        "YES": "Jā, Dzēst ",
        "NO": "Nē, Paturēt "
      },
      "API": {
        "SUCCESS_MESSAGE": "Iesūtne veiksmīgi izdzēsta",
        "MARKED_FOR_DELETION_MESSAGE": "Iesūtne atzīmēta dzēšanai",
        "RESTORE_SUCCESS_MESSAGE": "Iesūtne veiksmīgi atjaunota",
        "ERROR_MESSAGE": "Nevarēja izdzēst iesūtni. Lūdzu, vēlāk pamēģiniet vēlreiz.",
        "RESTORE_ERROR_MESSAGE": "Neizdevās atjaunot iesūtni. Lūdzu, vēlāk mēģiniet vēlreiz.",
        "AVATAR_SUCCESS_MESSAGE": "Iesūtnes avatārs ir veiksmīgi izdzēsts",
        "AVATAR_ERROR_MESSAGE": "Nevarēja izdzēst iesūtnes avatāru. Lūdzu, vēlāk pamēģiniet vēlreiz."
      }
    },
    "TABS": {
      "SETTINGS": "Iestatījumi",
      "COLLABORATORS": "Līdzstrādnieki",
      "AUTOMATIC_PRIORITY": "Automātiskā Prioritāte",
      "AUTOMATIC_LABELING": "Automātiskā Etiķešu Piešķiršana",
      "CONFIGURATION": "Konfigurācija",
      "CAMPAIGN": "Kampaņas",
      "PRE_CHAT_FORM": "Pirms-Tērzēšanas Veidlapa",
      "BUSINESS_HOURS": "Darba Laiks",
      "WIDGET_BUILDER": "Logrīku Veidotājs",
      "BOT_CONFIGURATION": "Robota Konfigurācija",
      "SLA": "SLA"
    },
    "SETTINGS": "Iestatījumi",
    "FEATURES": {
      "LABEL": "Īpašības",
      "DISPLAY_FILE_PICKER": "Logrīkā parādīt failu atlasītāju",
      "DISPLAY_EMOJI_PICKER": "Logrīkā parādīt emocijzīmju atlasītāju",
      "ALLOW_END_CONVERSATION": "Atļaut lietotājiem beigt sarunu no logrīka",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Rādīt pogu 'Sākt jaunu sarunu' logrīka galvenē",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Paslēpt ievades lauku, kad tiek rādīta poga sākt jaunu sarunu",
      "SHOW_HANDOFF_BUTTON": "Rādīt pogu 'Pārsūtīt operatoram' logrīka galvenē",
      "AUTO_CLOSE_OLD": "Atzīmēt visus iepriekšējos zvanus no tā paša numura kā atrisinātus, kad viens ir atrisināts",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Automātiski piešķirt neatbildētos zvanus, veicot izejošu zvanu",
      "USE_INBOX_AVATAR_FOR_BOT": "Izmantot iesūtnes nosaukumu un avataru priekš robota",
      "ALLOW_OFFLINE_REPLY": "Atļaut aģentiem sūtīt ziņojumus, kad kontaktpersona ir bezsaistē un e-pasta nepārtrauktība nav pieejama"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Skripts",
      "MESSENGER_SUB_HEAD": "Ievietojiet šo pogu savā body tagā",
      "INBOX_AGENTS": "Aģenti",
      "INBOX_TEAMS": "Komandas",
      "INBOX_COOPERATORS": "Līdzstrādnieki",
      "SELECT_PLACEHOLDER": "Izvēlēties",
      "AGENTS_OR_TEAMS_INFO": "Varat piešķirt vai nu aģentus, vai komandas - ne abus vienlaicīgi.",
      "INBOX_AGENTS_SUB_TEXT": "Pievienot vai noņemt aģentus no šīs iesūtnes",
      "AGENT_ASSIGNMENT": "Sarunas Piešķiršana",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Atjaunināt sarunas piešķiršanas iestatījumus",
      "UPDATE": "Atjaunināt",
      "ENABLE_EMAIL_COLLECT_BOX": "Iespējot e-pasta iegūšanas lodziņu",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Iespējot vai atspējot e-pasta iegūšanas lodziņu jaunai sarunai",
      "AUTO_ASSIGNMENT": "Iespējot automātisko piešķiršanu",
      "ENABLE_CSAT": "Iespējot CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Iespējot CSAT katrā ziņojumā",
      "SENDER_NAME_SECTION": "Iespējot Aģenta Vārdu E-pastā",
      "ENABLE_CSAT_SUB_TEXT": "Iespējot/Atspējot CSAT (klientu apmierinātības) aptauju pēc sarunas atrisināšanas",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Iespējot/Atspējot CSAT aptaujas opciju katram aģentu nosūtītajam ziņojumam",
      "SENDER_NAME_SECTION_TEXT": "Iespējot/Atspējot aģenta vārda rādīšanu e-pastā. Ja tas ir atspējots, tiks rādīts uzņēmuma nosaukums",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Iespējot sarunas nepārtrauktību, izmantojot e-pastu",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Sarunas turpināsies pa e-pastu, ja saziņas e-pasta adrese ir pieejama.",
      "RESPOND_FROM_EMAIL": "Atbildēt no e-pasta",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "E-pasti klientam — gan atbildes, gan sarunas transkripti — tiek sūtīti, izmantojot izvēlētās e-pasta iesūtnes SMTP iestatījumus, no izvēlētās adreses (iesūtnes paša adreses vai kādas no tās aizstājadresēm), un klienta atbildes tiek saņemtas atpakaļ caur tās IMAP adresi.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Sarunas transkripti tiek sūtīti, izmantojot izvēlētās e-pasta iesūtnes SMTP iestatījumus, no izvēlētās adreses (iesūtnes paša adreses vai kādas no tās aizstājadresēm), un atbildes tiek saņemtas atpakaļ caur tās IMAP adresi.",
      "SHOW_WELCOME_SCREEN": "Rādīt sveiciena ekrānu",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Rādīt sveiciena ekrānu, kad logrīks tiek atvērts. Ja atspējots, logrīks dosies tieši uz sarunas skatu.",
      "AUTO_CLOSE_PENDING": "Automātiski atrisināt AI tērzēšanas pēc (stundām)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Automātiski atrisina AI tērzēšanas pēc X stundu neaktivitātes.",
      "LOCK_TO_SINGLE_CONVERSATION": "Pieturēties pie vienas sarunas",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Iespējot vai atspējot vairākas sarunas vienai un tai pašai kontaktpersonai šajā iesūtnē",
      "INBOX_UPDATE_TITLE": "Iesūtnes Iestatījumi",
      "INBOX_UPDATE_SUB_TEXT": "Atjaunināt Jūsu iesūtnes iestatījumus",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Iespējot vai atspējot jaunu sarunu automātisku piešķiršanu šai iesūtnei pievienotajiem aģentiem.",
      "HMAC_VERIFICATION": "Lietotāja Identitātes Apstiprināšana",
      "HMAC_DESCRIPTION": "Izmantojot šo atslēgu, varat ģenerēt slepeno marķieri, ko var izmantot, lai pārbaudītu Jūsu lietotāju identitāti.",
      "HMAC_ROTATE": {
        "BUTTON": "Mainīt atslēgu",
        "TITLE": "Mainīt slepeno atslēgu?",
        "WARNING": "Pašreizējā atslēga tiek atsaukta tajā pašā brīdī, kad to nomaināt.",
        "WARNING_DETAIL": "Nav pārklāšanās perioda, un atslēgu nevar atjaunot.",
        "IMPACT": "Jūsu serveriem lietotāji jāparaksta ar jauno atslēgu. Ikviens, kurš joprojām parakstīts ar veco atslēgu, neiztur pārbaudi. Ja nepieciešama identitātes validācija, viņi nevar sākt sarunu.",
        "CONFIRM": "Mainīt atslēgu",
        "CANCEL": "Atcelt",
        "SUCCESS": "Slepenā atslēga veiksmīgi nomainīta",
        "ERROR": "Neizdevās nomainīt slepeno atslēgu, lūdzu, mēģiniet vēlreiz"
      },
      "HMAC_LINK_TO_DOCS": "Papildu informācija ir pieejama šeit.",
      "HMAC_MANDATORY_VERIFICATION": "Īstenot Lietotāja Identitātes Validāciju",
      "HMAC_MANDATORY_DESCRIPTION": "Ja iespējots, pieprasījumi, kurus nevar pārbaudīt, tiks noraidīti.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Piespiest jaunu sarunu katrā logrīka ielādes reizē",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Ja iespējots, logrīka atvēršana jaunā cilnē vai logā sāk jaunu sarunu.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Aizmirst kontaktpersonu, sākot jaunu sarunu",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Ja atspējots, no logrīka sākta jauna saruna saglabā iepriekšējo kontaktpersonu.",
      "INBOX_IDENTIFIER": "Iesūtnes identifikators",
      "INBOX_IDENTIFIER_SUB_TEXT": "Izmantojiet šeit uzrādīto `inbox_identifier` token, lai autentificētu savus API klientus.",
      "FORWARD_EMAIL_TITLE": "Pārsūtīt uz E-pastu",
      "FORWARD_EMAIL_SUB_TEXT": "Sākt pārsūtīt savus e-pasta ziņojumus uz tālāk norādīto e-pasta adresi.",
      "EMAIL_FETCHING_ENABLED_TITLE": "E-pasta Sinhronizācija",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Iespējot automātisku šīs iesūtnes ienākošo e-pastu sinhronizāciju un lejupielādi",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Pielāgots E-pasta Domēns",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Iespējot, lai izejošajiem e-pastiem izmantotu pielāgotu e-pasta domēnu",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Vairāk varat lasīt šeit.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook Komentāri",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Atļaut ziņojumus pēc sarunas pabeigšanas",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Ļaut galalietotājiem sūtīt ziņojumus pat pēc sarunas atrisināšanas.",
      "WIDGET_STATUS_LABEL": "Logrīka Statuss",
      "WIDGET_STATUS_ENABLED": "Iespējots",
      "WIDGET_STATUS_BUSINESS_HOURS": "Iespējots darba laikā",
      "WIDGET_STATUS_DISABLED": "Atspējots",
      "WIDGET_STATUS_HELP_TEXT": "Kontrolējiet, kad logrīks tiek rādīts apmeklētājiem Jūsu vietnē",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Atjaunināt pirms-tērzēšanas veidlapas iestatījumus",
      "EXPLICIT_CSAT_LOCALE": "CSAT Aptaujas un E-pasta Valoda",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Izvēlieties valodu visiem klientu e-pastiem, tostarp CSAT aptaujām, sarunu transkriptiem un e-pasta paziņojumiem",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Pārmantot no konta",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp savienojums",
        "SUBTITLE": "Kā šī iesūtne ir savienota ar WhatsApp.",
        "PROVIDER": "Pakalpojumu sniedzējs",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Savienots, izmantojot Meta iegulto reģistrāciju",
        "STATUS": "Statuss",
        "CONNECTED": "Savienots",
        "RECONNECT_HINT": "Noklikšķiniet uz Savienot atkārtoti paziņojumā augstāk.",
        "PHONE_NUMBER": "Tālruņa numurs",
        "BUSINESS_ACCOUNT": "WhatsApp Business konta ID",
        "OPEN_MANAGER": "Atvērt WhatsApp Manager",
        "PHONE_NUMBER_ID": "Tālruņa numura ID",
        "TEMPLATES": "Ziņojumu veidnes",
        "TEMPLATES_COUNT": "Apstiprinātas {approved} no {total}",
        "TEMPLATES_SYNCED": "Pēdējā sinhronizācija: {date}",
        "TEMPLATES_NOT_SYNCED": "Vēl nav sinhronizētas",
        "MANAGE_TEMPLATES": "Pārvaldīt veidnes"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Palīdzības centrs",
      "PLACEHOLDER": "Izvēlēties Palīdzības Centru",
      "SELECT_PLACEHOLDER": "Izvēlēties Palīdzības Centru",
      "REMOVE": "Noņemt Palīdzības Centru",
      "SUB_TEXT": "Pievienot Palīdzības Centru ar iesūtni"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Automātiskās piešķiršanas ierobežojums",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Lūdzu, ievadiet vērtību, kas ir lielāka par 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Ierobežo maksimālo sarunu skaitu no šīs iesūtnes, ko var automātiski piešķirt aģentam"
    },
    "SLA": {
      "TITLE": "SLA Politikas",
      "SUB_TEXT": "Konfigurējiet SLA atbildes un atrisināšanas laikus katram sarunas prioritātes līmenim.",
      "LOADING": "Notiek SLA politiku ielāde...",
      "FIELDS": {
        "ACTIVE": "Aktīvs",
        "TICKET_PRIORITY": "Sarunas prioritāte",
        "FIRST_RESPONSE_TIME": "Pirmās atbildes laiks",
        "EVERY_RESPONSE_TIME": "Katras atbildes laiks",
        "RESOLUTION_TIME": "Atrisināšanas laiks",
        "PLACEHOLDER": "piem., 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA politikas veiksmīgi atjauninātas.",
        "ERROR_MESSAGE": "Neizdevās atjaunināt SLA politikas. Lūdzu, mēģiniet vēlreiz."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automātiskā Prioritāte",
      "SUB_TEXT": "Konfigurējiet automātisku prioritātes piešķiršanu, pamatojoties uz sarunas saturu.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Norēķinu Paziņojums",
        "MESSAGE": "Par katru prioritātes izvērtējumu tiek piemērota maksa. Lūdzu, skatiet sava plāna informāciju par cenām."
      },
      "MODE": {
        "OFF": "Izslēgts",
        "ALL_MESSAGES": "Ieslēgts visiem ienākošajiem ziņojumiem",
        "FIRST_MESSAGE": "Ieslēgts tikai pirmajam ienākošajam ziņojumam"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Prioritātes Līmeņu Konfigurācija",
        "SUB_TEXT": "Konfigurējiet, kuri prioritātes līmeņi jāiespējo, un to aprakstus. Sniedziet skaidrus kritērijus AI, lai noteiktu, kad šī prioritāte jāpiešķir."
      },
      "DESCRIPTION_LABEL": "Apraksts",
      "DESCRIPTION_PLACEHOLDER": "Aprakstiet sarunas, kas jāatzīmē ar prioritāti {priority}",
      "SET_AS_DEFAULT": "Iestatīt kā noklusējuma prioritāti",
      "MULTIPLE_DEFAULTS_WARNING": "Kā noklusējums jābūt iestatītam tikai vienam prioritātes līmenim. Lūdzu, noņemiet atzīmi citiem noklusējumiem."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automātiskā Etiķešu Piešķiršana",
      "SUB_TEXT": "Konfigurējiet automātisku etiķešu piešķiršanu, pamatojoties uz sarunas saturu.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Norēķinu Paziņojums",
        "MESSAGE": "Par katru etiķešu izvērtējumu tiek piemērota maksa. Lūdzu, skatiet sava plāna informāciju par cenām."
      },
      "MODE": {
        "OFF": "Izslēgts",
        "CONVERSATION_OPEN": "Atverot sarunu",
        "CONVERSATION_CLOSE": "Aizverot sarunu",
        "ALL_MESSAGES": "Katram ziņojumam - neatkarīgi no statusa",
        "FIRST_MESSAGE": "Pirmajam ziņojumam - neatkarīgi no statusa"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Etiķešu Konfigurācija",
        "SUB_TEXT": "Konfigurējiet, kuras etiķetes jābūt pieejamām automātiskai piešķiršanai, un to aprakstus. Sniedziet skaidrus kritērijus AI, lai noteiktu, kad šī etiķete jāpiemēro."
      },
      "DESCRIPTION_LABEL": "Apraksts",
      "DESCRIPTION_PLACEHOLDER": "Aprakstiet sarunas, kas jāatzīmē ar etiķeti {label}. Ja atstāsiet tukšu, tiks izmantots etiķetes apraksts.",
      "NO_LABELS_MESSAGE": "Nav atrasta neviena etiķete. Vispirms izveidojiet etiķetes, lai iespējotu automātisku etiķešu piešķiršanu.",
      "CREATE_LABELS_LINK": "Izveidot etiķetes"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Atkārtoti autorizēties",
      "SUBTITLE": "Jūsu Facebook savienojuma derīguma termiņš ir beidzies. Lūdzu, atkārtoti pievienojiet savu Facebook lapu, lai turpinātu pakalpojumus",
      "MESSAGE_SUCCESS": "Atkārtota savienojuma izveide ir veiksmīga",
      "MESSAGE_ERROR": "Radās kļūda. Lūdzu, mēģiniet vēlreiz"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Pirms tērzēšanas veidlapas ļauj iegūt informāciju par lietotājiem, pirms viņi sāk ar Jums sarunu.",
      "SET_FIELDS": "Pirms tērzēšanas veidlapas lauki",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Lauki",
        "LABEL": "Etiķete",
        "PLACE_HOLDER": "Vietturis",
        "KEY": "Atslēga",
        "TYPE": "Tips",
        "REQUIRED": "Nepieciešams"
      },
      "ENABLE": {
        "LABEL": "Iespējot pirms tērzēšanas veidlapu",
        "OPTIONS": {
          "ENABLED": "Jā",
          "DISABLED": "Nē"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pirms tērzēšanas ziņojums",
        "PLACEHOLDER": "Šis ziņojums būs redzams lietotājiem, kopā ar veidlapu"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Apmeklētājiem pirms tērzēšanas ir jānorāda savs vārds un e-pasta adrese"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Iestatīt savu pieejamību",
      "SUBTITLE": "Iestatīt savu pieejamību tiešraides tērzēšanas logrīkā",
      "WEEKLY_TITLE": "Iestatīt savu darba laiku",
      "TIMEZONE_LABEL": "Izvēlieties laika joslu",
      "UPDATE": "Atjaunināt darba laika iestatījumus",
      "TOGGLE_AVAILABILITY": "Iespējot biznesa pieejamību šai iesūtnei",
      "UNAVAILABLE_MESSAGE_LABEL": "Ziņojums nav pieejams priekš apmeklētājiem",
      "TOGGLE_HELP": "Iespējojot uzņēmuma pieejamību, tiešraides tērzēšanas logrīkā tiks rādīts darba laiks, pat ja visi aģenti būs bezsaistē. Ārpus darba laika apmeklētājus var brīdināt ar ziņojumu un pirms tērzēšanas veidlapu.",
      "DAY": {
        "ENABLE": "Iespējot pieejamību šai dienai",
        "UNAVAILABLE": "Nav pieejams",
        "HOURS": "darba laiks",
        "VALIDATION_ERROR": "Sākuma laikam jābūt pirms slēgšanas laika.",
        "CHOOSE": "Izvēlēties"
      },
      "ALL_DAY": "Visu dienu",
      "SAVE_TO_ALL": "Saglabāt Visās Iesūtnēs",
      "SAVE_TO_ALL_TITLE": "Kopēt Darba Laiku",
      "SAVE_TO_ALL_CONFIRM": "Šīs veidlapas iestatījumi (pieejamības pārslēgs, prombūtnes ziņojums, laika josla un darba laiks) tiks kopēti visām pārējām iesūtnēm, izņemot e-pasta un tālruņa iesūtnes. Vai tiešām vēlaties turpināt?",
      "SAVE_TO_ALL_CANCEL": "Atcelt",
      "SAVE_TO_ALL_YES": "Jā, Kopēt Visām",
      "SAVE_TO_ALL_SUCCESS": "Darba laiks veiksmīgi nokopēts visām pārējām iesūtnēm",
      "SAVE_TO_ALL_ERROR": "Neizdevās nokopēt darba laiku pārējām iesūtnēm"
    },
    "PHONE": {
      "TITLE": "Tālruņa iestatījumi",
      "SUBTITLE": "Konfigurējiet, kuri zvani tiks rādīti šajā iesūtnē.",
      "UPDATE": "Saglabāt iestatījumus",
      "EDIT": {
        "SUCCESS_MESSAGE": "Tālruņa iestatījumi atjaunināti"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Tālruņa numuri",
        "PLACEHOLDER": "+145123908635"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Iestatīt IMAP informāciju",
      "NOTE_TEXT": "Lai iespējotu SMTP, lūdzu, nokonfigurējiet IMAP.",
      "UPDATE": "Atjaunināt IMAP iestatījumus",
      "TOGGLE_AVAILABILITY": "Iespējot IMAP konfigurāciju šai iesūtnei",
      "TOGGLE_HELP": "Iespējojot IMAP, lietotājs varēs saņemt e-pastu",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP iestatījumi ir veiksmīgi atjaunināti",
        "ERROR_MESSAGE": "Nevar atjaunināt IMAP iestatījumus"
      },
      "ADDRESS": {
        "LABEL": "Adrese",
        "PLACE_HOLDER": "Adrese (piemēram: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Ports",
        "PLACE_HOLDER": "Ports"
      },
      "LOGIN": {
        "LABEL": "Lietotājvārds",
        "PLACE_HOLDER": "Lietotājvārds"
      },
      "PASSWORD": {
        "LABEL": "Parole",
        "PLACE_HOLDER": "Parole"
      },
      "ENABLE_SSL": "Iespējot SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Atkārtoti autorizēt savu MICROSOFT kontu"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Iestatīt SMTP informāciju",
      "UPDATE": "Atjaunināt SMTP iestatījumus",
      "TOGGLE_AVAILABILITY": "Iespējot SMTP konfigurāciju šai iesūtnei",
      "TOGGLE_HELP": "Iespējojot SMTP lietotājs varēs nosūtīt e-pastu",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP iestatījumi ir veiksmīgi atjaunināti",
        "ERROR_MESSAGE": "Nevar atjaunināt SMTP iestatījumus"
      },
      "ADDRESS": {
        "LABEL": "Adrese",
        "PLACE_HOLDER": "Adrese (piemēram: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Ports",
        "PLACE_HOLDER": "Ports"
      },
      "LOGIN": {
        "LABEL": "Lietotājvārds",
        "PLACE_HOLDER": "Lietotājvārds"
      },
      "PASSWORD": {
        "LABEL": "Parole",
        "PLACE_HOLDER": "Parole"
      },
      "DOMAIN": {
        "LABEL": "Domēns",
        "PLACE_HOLDER": "Domēns"
      },
      "ENCRYPTION": "Šifrēšana",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Open SSL Verify Režīms",
      "AUTH_MECHANISM": "Autentifikācija"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "E-pasta piegādājamība (DNS)",
      "SUB_TITLE": "Mēs katru darbdienu pārbaudām domēna {domain} SPF, DKIM, DMARC un MX ierakstus. Ja kaut kas liek saņēmēju serveriem noraidīt jūsu atbildes vai atzīt tās par surogātpastu, administratori saņem e-pastu ar labojumu.",
      "RUN": "Palaist pārbaudi",
      "RUN_SUCCESS": "DNS pārbaude pabeigta",
      "RUN_ERROR": "Neizdevās palaist DNS pārbaudi, lūdzu, mēģiniet vēlreiz",
      "NOT_CHECKED": "Vēl nav pārbaudīts.",
      "CHECKED_AT": "Pēdējā pārbaude: {time}.",
      "DNS_UNAVAILABLE": "Pēdējās pārbaudes laikā domēna vārdu serveri neatbildēja. Zemāk redzams iepriekšējās pārbaudes rezultāts.",
      "SENDER": {
        "SMTP": "Atbildes tiek sūtītas caur {host}.",
        "PLATFORM": "Atbildes tiek sūtītas caur mūsu pasta serveriem."
      },
      "STATUS": {
        "OK": "Visi ieraksti ir kārtībā",
        "WARNING": "Daži ieraksti varētu būt labāki",
        "ERROR": "Atbildes var nenonākt pie saņēmējiem",
        "UNKNOWN": "Nav zināms"
      },
      "SEVERITY": {
        "ERROR": "Problēma",
        "WARNING": "Brīdinājums"
      },
      "FIX": "Izlabojiet to ar šo DNS ierakstu:",
      "RECORD_TYPE": "Tips",
      "RECORD_HOST": "Nosaukums",
      "RECORD_VALUE": "Vērtība",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "SPF ieraksts nav atrasts",
          "DESCRIPTION": "Domēns nenorāda, kuri serveri drīkst sūtīt tā e-pastus. Daudzi pasta serveri tāpēc uzskata jūsu atbildes par surogātpastu. Pievienojiet SPF ierakstu, kas atļauj {sender}."
        },
        "spf_multiple": {
          "TITLE": "Domēnam ir {count} SPF ieraksti",
          "DESCRIPTION": "Domēnam drīkst būt tikai viens SPF ieraksts. Ja to ir vairāk, saņēmēju serveri SPF ignorē un bieži noraida e-pastu. Apvienojiet tos vienā ierakstā."
        },
        "spf_not_authorized": {
          "TITLE": "SPF neatļauj serveri, kas sūta jūsu atbildes",
          "DESCRIPTION": "Jūsu atbildes tiek sūtītas caur {sender}, taču domēna SPF ierakstā tas nav norādīts. Pašreizējais ieraksts: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "SPF ierakstam vajadzīgi pārāk daudzi DNS pieprasījumi",
          "DESCRIPTION": "Saņēmēju serveri pārtrauc SPF pārbaudi pēc {limit} DNS pieprasījumiem, bet {sender}, kas sūta jūsu atbildes, tiek sasniegts tikai pēc {lookups}. Jūsu atbildes neiztur SPF pārbaudi. Pārvietojiet {sender} uz ieraksta sākumu un noņemiet include ierakstus, ko domēns vairs neizmanto."
        },
        "spf_lookups_others": {
          "TITLE": "Daži SPF ieraksta sūtītāji ir aiz pieprasījumu robežas",
          "DESCRIPTION": "SPF ierakstam vajadzīgi {lookups} DNS pieprasījumi, saņēmēju serveri pārtrauc pēc {limit}. Jūsu atbildes tiek atpazītas laikā un iztur pārbaudi, taču pasts no šiem sūtītājiem SPF neiztur: {senders}. Noņemiet include ierakstus, ko domēns vairs neizmanto."
        },
        "spf_malformed": {
          "TITLE": "SPF ieraksts ir bojāts",
          "DESCRIPTION": "Saņēmēju serveri nevar nolasīt domēna SPF ierakstu, tāpēc tas jūsu atbildes neaizsargā. Problēma ir šeit: {terms}. Aizstājiet ierakstu ar labotu."
        },
        "dkim_missing": {
          "TITLE": "DKIM paraksts nav iestatīts",
          "DESCRIPTION": "Pie {selectors} nav atrasta neviena DKIM atslēga. Bez tās jūsu atbildes netiek parakstītas un biežāk nonāk surogātpastā. Ieslēdziet DKIM parakstīšanu šim domēnam pie sava e-pasta pakalpojuma sniedzēja."
        },
        "dmarc_missing": {
          "TITLE": "DMARC ieraksts nav atrasts",
          "DESCRIPTION": "Lielie pasta pakalpojumu sniedzēji, piemēram, Gmail un Microsoft, sagaida DMARC ierakstu. Bez tā jūsu atbildes biežāk nonāk surogātpastā."
        },
        "dmarc_fails": {
          "TITLE": "DMARC liek saņēmējiem noraidīt jūsu atbildes",
          "DESCRIPTION": "Domēna DMARC politika ir „{policy}“, un jūsu atbildes neiztur ne SPF, ne DKIM pārbaudi, tāpēc saņēmēji tās noraida vai pārvieto uz surogātpastu. Izlabojiet SPF un DKIM iepriekš."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC bloķē atbildes, kas sūtītas caur mūsu pasta serveriem",
          "DESCRIPTION": "Šī pastkaste sūta atbildes caur mūsu pasta serveriem, taču domēna DMARC politika ir „{policy}“, tāpēc saņēmēji tās noraida vai pārvieto uz surogātpastu. Iestatiet šai pastkastei sava pasta servera SMTP."
        },
        "mx_missing": {
          "TITLE": "Domēnam nav MX ieraksta",
          "DESCRIPTION": "Bez MX ieraksta neviens nevar sūtīt e-pastus uz šo domēnu, tāpēc klienti nevar atbildēt uz jūsu atbildēm."
        }
      }
    },
    "NOTE": "Piezīme: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Tīmekļa Vietnes Avatārs",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatārs ir veiksmīgi izdzēsts",
              "ERROR_MESSAGE": "Radās kļūda. Lūdzu, mēģiniet vēlreiz"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Tīmekļa Vietnes Nosaukums",
          "PLACE_HOLDER": "Ievadiet Jūsu tīmekļa vietnes nosaukumu (piemēram: Acme Inc)",
          "ERROR": "Lūdzu, ievadiet derīgu tīmekļa vietnes nosaukumu"
        },
        "WELCOME_HEADING": {
          "LABEL": "Laipni lūdzam Virsraksts",
          "PLACE_HOLDER": "Sveicināti!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Laipni lūdzam Teksts",
          "PLACE_HOLDER": "Sazināties ar mums ir vienkārši. Vaicājiet mums jebko, vai dalieties ar savām atsauksmēm."
        },
        "REPLY_TIME": {
          "LABEL": "Atbildes Laiks",
          "IN_A_FEW_MINUTES": "Dažās minutēs",
          "IN_A_FEW_HOURS": "Dažās stundās",
          "IN_A_DAY": "Dienas laikā"
        },
        "WIDGET_COLOR_LABEL": "Logrīka Krāsa",
        "WIDGET_BUBBLE_POSITION_LABEL": "Logrīka Burbuļa Pozīcija",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Nelasīto ziņojumu maksimālais augstums (px)",
          "PLACE_HOLDER": "Bez ierobežojuma",
          "HELP_TEXT": "Ierobežojiet nelasīto ziņojumu uznirstošā loga maksimālo augstumu pikseļos. Atstājiet tukšu noklusējuma darbībai (bez ierobežojuma)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Logrīka Burbuļa Tips",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Tērzējiet ar mums",
          "LABEL": "Logrīka Burbuļa Palaidēja Nosaukums",
          "PLACE_HOLDER": "Tērzējiet ar mums"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Atjaunināt Logrīka Iestatījumus",
          "API": {
            "SUCCESS_MESSAGE": "Logrīka iestatījumi ir veiksmīgi atjaunināti",
            "ERROR_MESSAGE": "Nevar atjaunināt logrīka iestatījumus"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Priekšskatījums",
          "SCRIPT": "Skripts"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Pa kreisi",
          "RIGHT": "Pa labi"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standarta",
          "EXPANDED_BUBBLE": "Izvērsts Burbulis"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Noklusējums",
        "CHAT": "Tērzēšana"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Parasti atbild dažu minūšu laikā",
        "IN_A_FEW_HOURS": "Parasti atbild dažu stundu laikā",
        "IN_A_DAY": "Parasti atbild vienas dienas laikā"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Sākt Sarunu",
        "CHAT_INPUT_PLACEHOLDER": "Rakstiet savu ziņojumu"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Mēs esam Tiešsaistē",
          "OFFLINE": "Šobrīd neesam uz vietas"
        },
        "USER_MESSAGE": "Sveicināti",
        "AGENT_MESSAGE": "Labdien"
      },
      "BRANDING_TEXT": "Darbināts ar JARABOT",
      "SCRIPT_SETTINGS": "\nwindow.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Citi Pakalpojuma Sniedzēji"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Tīmekļa vietne",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "E-pasts",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API Kanāls",
      "PHONE": "SIP Tālrunis",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
